export enum EVoiceSessionStatus {
  IDLE = 'IDLE',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  PREPARING = 'PREPARING',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  ENDED = 'ENDED',
  ERROR = 'ERROR'
}

export enum EStudySessionStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  ABANDONED = 'ABANDONED'
}

export enum ETopicStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  VERIFIED = 'verified',
  NEEDS_WORK = 'needs_work',
  SKIPPED = 'skipped'
}

export enum ETopicOrigin {
  ORIGINAL = 'original',
  REINFORCEMENT = 'reinforcement',
  REVISIT = 'revisit'
}

export enum EPlanDifficulty {
  BASIC = 'basic',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced'
}

export enum ESimplificationLevel {
  SAME = 'same',
  SIMPLER = 'simpler',
  MUCH_SIMPLER = 'much_simpler'
}

export enum EMasteryLevel {
  NOT_STARTED = 'not_started',
  STRUGGLING = 'struggling',
  LEARNING = 'learning',
  MASTERED = 'mastered'
}

export enum EFrustrationLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export enum EStudentConfidence {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export enum EAdaptiveAction {
  ADVANCE = 'advance',
  REINFORCE = 'reinforce',
  SIMPLIFY = 'simplify',
  ENCOURAGE = 'encourage',
  CHALLENGE = 'challenge'
}

export enum EReinforcementReason {
  REPEATED_ERRORS = 'repeated_errors',
  CONFUSION_DETECTED = 'confusion_detected',
  STUDENT_REQUEST = 'student_request',
  LOW_CONFIDENCE = 'low_confidence'
}

export enum EPaceAdjustment {
  SLOW_DOWN = 'slow_down',
  SPEED_UP = 'speed_up',
  TAKE_BREAK = 'take_break',
  CHANGE_APPROACH = 'change_approach'
}

export enum ERevisitApproach {
  SAME = 'same',
  DIFFERENT_EXAMPLES = 'different_examples',
  MORE_PRACTICE = 'more_practice'
}
